import { h } from "omi";

export function PortfolioHeaderSkeleton() {
  return (
    <div className="space-y-2 pb-10 animate-in fade-in ">
      <div className="relative">
        <div className="h-10 bg-secondary rounded animate-pulse" />
      </div>

      <div className="relative">
        <div className="h-28 bg-secondary rounded animate-pulse" />
      </div>

      <div className="relative">
        <div className="h-12 bg-secondary rounded animate-pulse" />
      </div>
    </div>
  );
}
